<div class="daily-record">
  <ng-container [ngSwitch]="screen">
    <ng-container *ngSwitchCase="screenKIDS.AREDASITE">
      <ng-container *ngTemplateOutlet="default"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="screenKIDS.KIROKU">
      <ng-container *ngTemplateOutlet="kiroku"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="screenKIDS.CASEFILE">
      <ng-container *ngTemplateOutlet="casefile"></ng-container>
    </ng-container>
  </ng-container>
</div>


<ng-template #default>
  <div class="schedule">
    <div class="header-sticky top40">
      <div class="tab-row header" id="name-header">
        <span>{{ name }} {{isOfficeRecord ? '':''}}</span>
      </div>
      <ng-container *ngIf="sdate && edate">
        <div class="tab-row period" id="name-header">
          <span>{{sdate | date: "yyyy年M月d日 (E)" }}</span>
          <span>~</span>
          <span>{{edate | date: "yyyy年M月d日 (E)"}}</span>
        </div>
      </ng-container>
    </div>
    <!-- loop here first -->
    <ng-container *ngFor="let date of data.notes">
      <div class="tab-row date-tab" id="date-tab">
        <span>{{date.date | date: "yyyy年M月d日"}}</span>
      </div>
      <ul *ngIf="date.data?.length">
        <ul class="record-list">
          <li *ngFor="let note of date.data">
            <app-record-item [record]="note" [titles]="titles" [isFull]="true"></app-record-item>
          </li>
        </ul>
      </ul>
    </ng-container>
  </div>
</ng-template>

<ng-template #kiroku>
  <div class="schedule kiroku">
    <div class="header-sticky top40" *ngIf="userHeader">
      <div class="tab-row header" id="name-header">
        <span>{{ name }} {{isOfficeRecord ? '':''}}</span>
      </div>

    </div>
    <!-- loop here first -->
    <ng-container *ngFor="let date of data.notes">
      <div class="tab-row date-tab" id="date-tab">
        <span>{{date.date | date: "yyyy年M月d日(E)"}}</span>
      </div>
      <ul *ngIf="date.data?.length">
        <ul class="record-list">
          <li *ngFor="let note of date.data">
            <app-record-item [record]="note" [titles]="titles" [isFull]="true"></app-record-item>
          </li>
        </ul>
      </ul>
    </ng-container>
  </div>
</ng-template>

<ng-template #casefile>
  <div class="schedule kiroku">
    <div class="header-sticky top40" *ngIf="userHeader">
      <div class="tab-row header" id="name-header">
        <span>{{ name }}</span>
      </div>
    </div>
    <ng-container *ngFor="let date of data.notes">
      <div class="tab-row date-tab" id="date-tab">
        <span>{{date.date | date: "yyyy年M月d日(E)"}}</span>
      </div>
      <ul *ngIf="date.data?.length">
        <ul class="record-list">
          <li *ngFor="let note of date.data">
            <app-record-item [record]="note" [titles]="titles" [isFull]="true"></app-record-item>
          </li>
        </ul>
      </ul>
    </ng-container>
  </div>
</ng-template>